var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopaHelado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 64,
    height: 64,
    viewBox: "0 0 47.5 47.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38h38V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.918 24H6.999c-1.175 0-3.739-.493-3.071-2.894C6.711 11.1 17 8.375 17 8.375V7.202s-4.634-2.443-5.588-3.01c-1.027-.587-.267-1.526.144-1.688.684-.269 2.389-1.15 7.115-1.15 4.848 0 7.497.954 8.084 1.15.226.075 1.197.973-.199 1.799C24.073 5.773 21 7.202 21 7.202v1.173S31.661 11.1 34.357 21.281C34.753 22.775 32.838 24 30.488 24z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38h38V0H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 47.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0s10.661 2.725 13.356 12.905c.397 1.495-1.518 2.72-3.868 2.72H-14c-1.176 0-3.74-.493-3.072-2.895C-14.289 2.725-4 0-4 0v-1.173s-4.634-2.443-5.588-3.01c-1.027-.588-.267-1.526.144-1.688.684-.27 2.389-1.15 7.115-1.15 4.848 0 7.497.954 8.084 1.15.226.075 1.197.973-.198 1.799C3.073-2.603 0-1.173 0-1.173z",
    style: {
      fill: "#55acee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(21 8.375)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-1.692-6.835-3.063-15.269-3.063-8.432 0-15.268 1.371-15.268 3.063s6.836 3.064 15.268 3.064C-6.835 3.064 0 1.693 0 0",
    style: {
      fill: "#3b88c3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(34.291 21.752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-1.613-3.133-4.745-7.832-4.745-4.325 0-7.831 2.088-7.831 4.745 0 4.325 3.506 6.787 7.831 6.787S0 4.325 0 0",
    style: {
      fill: "#f4abba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(26.982 30.092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-1.613-3.132-4.223-7.83-4.223-4.326 0-7.833-1.393-7.833 4.223A7.832 7.832 0 0 0 0 0",
    style: {
      fill: "#ffe8b6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(34.291 22.783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-5.182-3.132-4.311-7.831-4.311-4.324 0-7.83 1.654-7.83 4.311A7.83 7.83 0 1 0 0 0",
    style: {
      fill: "#8a4b38",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(19.672 22.783)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(1.25 0 0 -1.25 0 47.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.915-.609 16.185-5.264 31.281.522.087-.826-.219-3.742-1.436-3.959-1.218-.216-14.232-4.496-28.762.202C.691-2.8 0 0 0 0",
    style: {
      fill: "#3b88c3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(3.75 19.777)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(1.25 0 0 -1.25 0 47.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.396-.6 15.488-5.046 30.498-.087 0-.653-.411-2.477-.653-3.176-.391-1.132-15.401-4.829-28.888-.261C.565-3.35-.609.261 0 0",
    style: {
      fill: "#55acee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(3.837 21.823)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopaHelado);
export default __webpack_public_path__ + "static/media/CopaHelado.066d7c4f9fa9b3f2aecd146623632ba5.svg";
export { ForwardRef as ReactComponent };